export enum GoalDistribution {
  NONE = 'NONE',
  OWNERS = 'OWNERS',
  COMPANY = 'COMPANY'
}
